import {
  AddIcon,
  Box,
  Divider,
  HStack,
  Pressable,
  ScrollView,
  Text,
  VStack,
  Button,
  Spinner,
} from "native-base";
import React, {
  FC,
  useState,
  useRef,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import Tooltip from "@mui/material/Tooltip";
import AVCancel from "../../components/common/AVCancel";
import AVEmoji from "../../components/common/AVEmoji";
import * as AV from "../../AVCore/AVCore";
import {
  DropdownIcon,
  BrushIcon,
  CircleSlashIcon,
  FormattingIcon,
  PlainTextIcon,
  DollarCoinsIcon,
} from "../../assets/icons/icon-assets";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import { Loc } from "../../App/Loc";
import { RootStateOrAny, useSelector, useDispatch } from "react-redux";
import { setUser, setEntitydata } from "../../Redux/Actions/userActions";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import type SunEditorCore from "suneditor/src/lib/core";
import { SketchPicker } from "react-color";
import AVEmojiPicker from "../../components/common/AVEmojiPicker";
import PurchaseCreditsPopup from "../../components/common/PurchaseCreditsPopup";

interface Props {
  entity: AV.IAVEntity;
  paySend: number;
  setPaySend: Dispatch<SetStateAction<number>>;
  subject: string;
  setSubject: Dispatch<SetStateAction<string>>;
  estimate: number | null;
  setEstimate: Dispatch<SetStateAction<number | null>>;
  showBoostPostPopup: boolean;
  setShowBoostPostPopup: Dispatch<SetStateAction<boolean>>;
  showCreditsPopup: boolean;
  setShowCreditsPopup: Dispatch<SetStateAction<boolean>>;
  boostPostOwner: AV.IFK | undefined;
  visibility?: string;
  postContent?: string;
  editPostPaySend?: number;
  editPostSubject?: string;
  sharedPlan?: AV.ISharedPlan;
  setSharedPlan?: (plan: AV.ISharedPlan) => void;
  handleToggleRichTextPost?: () => void;
  handleToggleRichTextSubject?: () => void;
}

const AVBoostPostPopup: FC<Props> = ({
  entity,
  paySend,
  setPaySend,
  subject,
  setSubject,
  estimate,
  setEstimate,
  showBoostPostPopup,
  setShowBoostPostPopup,
  showCreditsPopup,
  setShowCreditsPopup,
  boostPostOwner,
  visibility,
  postContent,
  editPostPaySend,
  editPostSubject,
  sharedPlan,
  setSharedPlan,
  handleToggleRichTextPost,
  handleToggleRichTextSubject,
}) => {
  const dispatch = useDispatch();
  const dimensions = useWindowDimension();
  const mobile = dimensions?.width < 600 || false;

  const currentUser = useSelector(
    (state: RootStateOrAny) => state.user.user[0],
  );
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );

  const textRef = useRef<any>(null);
  const [picker, setPicker] = useState(false);
  const fk: AV.IFK = AV.AVEntity.getFk(entity);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [textValue, setTextValue] = useState(subject ?? "");
  const [creditsAvailable, setCreditsAvailable] = useState<number>(0);
  const [isEditorDialogVisible, setIsEditorDialogVisible] = useState(false);
  const [finalEntity, setFinalEntity] = useState<AV.IAVEntity | undefined>(
    entity ?? currentUser,
  );
  const [isOwner, setIsOwner] = useState(
    sharedPlan?.owner?.id === finalEntity?.id,
  );
  const paySendOptionsAll = [
    { label: Loc.currentLang.boostPost.none, value: 0 },
    { label: Loc.currentLang.boostPost.email, value: 1 },
    { label: Loc.currentLang.boostPost.textOrEmail, value: 2 },
    { label: Loc.currentLang.boostPost.both, value: 3 },
  ];

  const paySendOptionsEmail = [
    { label: Loc.currentLang.boostPost.none, value: 0 },
    { label: Loc.currentLang.boostPost.email, value: 1 },
  ];

  const visibilityMap: Record<string, string> = {
    [Loc.currentLang.menu.followers]: "Follow",
    [Loc.currentLang.menu.organizations]: "Org",
    [Loc.currentLang.menu.public]: "Public",
    [Loc.currentLang.menu.private]: "Private",
  };

  //// RichTextEditor(Formatting Post)
  //const editorRef = useRef<SunEditorCore | null>(null);
  //const customFonts = [
  //  "Arial",
  //  "Calibri",
  //  "Cambria",
  //  "Candara",
  //  "Comic Sans MS",
  //  "Consolas",
  //  "Constantia",
  //  "Corbel",
  //  "Courier New",
  //  "Georgia",
  //  "Impact",
  //  "Lucida Console",
  //  "Lucida Sans Unicode",
  //  "Palatino Linotype",
  //  "Segoe Print",
  //  "Segoe Script",
  //  "Segoe UI",
  //  "Tahoma",
  //  "Times New Roman",
  //  "Trebuchet MS",
  //  "Verdana",
  //];
  //const customLang: any = {
  //  code: currentUser?.preferences?.lang ?? "en",
  //  toolbar: Loc.currentLang.richText.toolbar,
  //  dialogBox: {
  //    linkBox: Loc.currentLang.richText.linkBox,
  //    imageBox: Loc.currentLang.richText.imageBox,
  //    videoBox: Loc.currentLang.richText.videoBox,
  //    audioBox: Loc.currentLang.richText.audioBox,
  //  },
  //  controller: Loc.currentLang.richText.controller,
  //  menu: {},
  //};
  //const toolbarOptions = {
  //  buttonList: [
  //    ["font", "fontSize"],
  //    ["fontColor", "hiliteColor"],
  //    ["bold", "italic", "underline", "strike"],
  //    ["align", "list"],
  //    ["link", "image"],
  //    ["undo", "redo"],
  //  ],
  //  showPathLabel: false,
  //  defaultStyle: "font-family: Arial; font-size: 16px;",
  //  placeholder: Loc.currentLang.boostPost.addSubject,
  //  font: customFonts,
  //  fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 64, 128],
  //};

  //const [bgColor, setBgColor] = useState<string>("");
  //const [bgImage, setBgImage] = useState<string>("");
  //const [bgImgWidth, setBgImgWidth] = useState<string>("");
  //const [bgImgHeight, setBgImgHeight] = useState<string>("");
  //const [showBgImgMenu, setShowBgImgMenu] = useState(false);
  //const [showColorPicker, setShowColorPicker] = useState(false);
  //const colorInputRef = useRef<HTMLInputElement | null>(null);
  //const fileInputRef = useRef<HTMLInputElement | null>(null);
  //const editorContainerRef = useRef<HTMLDivElement | null>(null);
  //const colorPickerRef = useRef<HTMLDivElement | null>(null);
  //const bgImgMenuRef = useRef<HTMLDivElement | null>(null);

  //useEffect(() => {
  //  const handleClickOutside = (e: MouseEvent) => {
  //    if (
  //      colorPickerRef.current &&
  //      !colorPickerRef.current.contains(e.target as Node)
  //    ) {
  //      setShowBgImgMenu(false);
  //      setShowColorPicker(false);
  //    }
  //  };
  //  document.addEventListener("mousedown", handleClickOutside);
  //  return () => document.removeEventListener("mousedown", handleClickOutside);
  //}, []);

  //useEffect(() => {
  //  const handleClickOutside = (event: MouseEvent) => {
  //    if (
  //      bgImgMenuRef.current &&
  //      !bgImgMenuRef.current.contains(event.target as Node)
  //    ) {
  //      setShowBgImgMenu(false);
  //      setShowColorPicker(false);
  //    }
  //  };

  //  if (showBgImgMenu) {
  //    document.addEventListener("mousedown", handleClickOutside);
  //  } else {
  //    document.removeEventListener("mousedown", handleClickOutside);
  //  }

  //  return () => {
  //    document.removeEventListener("mousedown", handleClickOutside);
  //  };
  //}, [showBgImgMenu]);

  //const handleColorChange = (color: any) => {
  //  setBgImage("");
  //  setBgImgWidth("");
  //  setBgImgHeight("");
  //  setBgColor(color.hex);

  //  const editableArea = document.querySelector<HTMLDivElement>(
  //    ".sun-editor-editable.boost-sun-editor",
  //  );
  //  if (editableArea) {
  //    // Remove any inline background-color or wrapper divs
  //    editableArea.innerHTML = editableArea.innerHTML
  //      // Remove inline background-color styles
  //      .replace(/background-color:\s*#[0-9A-Fa-f]{3,6};?/g, "")
  //      // Remove redundant wrapping <div style=""> if empty
  //      .replace(/<div[^>]*>([\s\S]*?)<\/div>/g, "$1");

  //    // Reset editor area styling
  //    editableArea.style.backgroundImage = "unset";
  //    editableArea.style.backgroundSize = "unset";
  //    editableArea.style.backgroundPosition = "unset";
  //    editableArea.style.backgroundRepeat = "unset";
  //    editableArea.style.height = "20vh";
  //    editableArea.style.minHeight = "20vh";
  //    editableArea.style.width = "unset";
  //    editableArea.style.minWidth = "unset";

  //    editableArea.style.backgroundColor = color.hex;
  //  }
  //};

  //const hasContent = (html: string) => {
  //  const tempDiv = document.createElement("div");
  //  tempDiv.innerHTML = html || "";

  //  let text = tempDiv.textContent || "";
  //  text = text.replace(/[\u200B-\u200D\uFEFF]/g, "").trim();
  //  if (text.length > 0) return true; // has real text

  //  // Check if HTML contains <img> or <video> tags
  //  if (tempDiv.querySelector("img, video")) return true;

  //  return false;
  //};

  const handleGetEstimate = async (paySendValue: number = 0) => {
    try {
      setLoading(true);

      // Prepare minimal post data for estimate
      let finalFk: AV.IFK = boostPostOwner ?? fk;

      if (boostPostOwner?.type === "Person") {
        finalFk =
          currentUser?.id !== boostPostOwner.id
            ? AV.AVEntity.getFk(currentUser)
            : boostPostOwner;
      }
      console.log("finalFk: ", finalFk);
      const post: AV.IPost = {
        pk: finalFk.id,
        region: finalFk.region,
        text: postContent,
        owner: finalFk,
        paySend: paySendValue || paySend,
        visibility:
          visibility === "Private" ||
          visibility === "Public" ||
          visibility === "Follow" ||
          visibility === "Org"
            ? visibility
            : (visibilityMap[visibility ?? ""] ?? undefined),
        person: finalFk,
      };

      const cost = await AV.Post.estimateBoost(post);
      setEstimate(cost);
    } catch (error) {
      console.error("Error getting estimate:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOk = async () => {
    let subContent = textValue || "";

    //if (useRichText) {
    //  // Wrap content with the current background color/image
    //  if (bgColor || bgImage) {
    //    subContent = `<div style="
    //      ${bgColor ? `background-color: ${bgColor};` : ""}
    //      ${
    //        bgImage
    //          ? `
    //        background-image: url(${bgImage});
    //        background-size: contain;
    //        background-position: left;
    //        background-repeat: no-repeat;
    //        width: ${bgImgWidth ? `${bgImgWidth}px` : "auto"};
    //        height: ${bgImgHeight ? `${bgImgHeight}px` : "auto"};
    //      `
    //          : ""
    //      }
    //    ">${subContent}</div>`;
    //  }
    //}

    setSubject(subContent);
    setShowBoostPostPopup(false);
  };

  const menuRefs = useRef(null);
  useOutsideAlerter(menuRefs);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActive(false);
          setPicker(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const dropdownRef = useRef(null);
  useOutsideDropdownRef(dropdownRef);

  function useOutsideDropdownRef(ref) {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsActive(false);
        }
      };

      if (isActive) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, isActive, setIsActive]);
  }

  useEffect(() => {
    // when popup opens, focus and move cursor to end
    if (showBoostPostPopup && textRef.current) {
      const textarea = textRef.current;
      textarea.focus();

      // Move cursor to the end of existing text
      const value = textarea.value;
      textarea.setSelectionRange(value.length, value.length);
    }

    if (showBoostPostPopup && paySend > 0) {
      handleGetEstimate(paySend);
    }
  }, [showBoostPostPopup]);

  useEffect(() => {
    if (!entity) return;

    const controller = new AbortController();

    const getEntity = async () => {
      try {
        let finalFk: AV.IFK = boostPostOwner ?? fk;

        if (boostPostOwner?.type === "Person") {
          finalFk =
            currentUser?.id !== boostPostOwner.id
              ? AV.AVEntity.getFk(currentUser)
              : boostPostOwner;
        }

        // Event Or Channel use OWNER (parent)
        if (finalFk?.type === "Event" || finalFk?.type === "Channel") {
          let parent: AV.ILink | null = null;

          if (entity?.parent) {
            parent = entity.parent;
          } else {
            const evtEntity =
              entityDataList?.find((x) => x?.id === finalFk.id) ?? null;

            if (evtEntity) {
              parent = evtEntity.parent ?? null;
            } else {
              const evtEntityAPI: AV.IAVEntity | null =
                await AV.AVEntity.get(finalFk);

              if (evtEntityAPI) {
                entityDataList?.push(evtEntityAPI);
                dispatch(setEntitydata(entityDataList));
                parent = evtEntityAPI.parent ?? null;
              }
            }
          }

          if (parent) {
            finalFk = parent;
          }
        }

        console.log("finalFk: ", finalFk);
        console.log("sharedPlan: ", sharedPlan);
        let entityData =
          entityDataList?.find((x) => x?.id === finalFk.id) ?? null;

        //if (entityData) {
        //  setCreditsAvailable(entityData.plan?.credits ?? 0);
        //  return;
        //}

        if (!entityData) {
          const entityDataAPI: AV.IAVEntity | null =
            await AV.AVEntity.get(finalFk);

          if (!controller.signal.aborted && entityDataAPI) {
            entityData = entityDataAPI;
            entityDataList?.push(entityDataAPI);
            dispatch(setEntitydata(entityDataList));
            //setCreditsAvailable(entityDataAPI.plan?.credits ?? 0);
          }
        }

        if (!entityData) return;

        setFinalEntity(entityData);
        // Shared plan check
        if (entityData.plan?.shared) {
          let shared =
            entityDataList?.find(
              (x) => x?.id === entityData.plan?.shared?.id,
            ) ?? null;

          if (!shared) {
            shared = await AV.AVEntity.getSharedPlan(
              AV.AVEntity.getFk(entityData),
            );
            if (!controller.signal.aborted && shared) {
              setSharedPlan?.(shared);
              entityDataList?.push(shared);
              dispatch(setEntitydata(entityDataList));
              setCreditsAvailable(shared?.plan?.credits ?? 0);
              setIsOwner(shared?.owner?.id === entityData?.id);
              return;
            }
          }

          setSharedPlan?.(shared);
          setCreditsAvailable(shared?.plan?.credits ?? 0);
          setIsOwner(shared?.owner?.id === entityData?.id);
          return;
        }

        setIsOwner(false);
        setCreditsAvailable(entityData.plan?.credits ?? 0);
      } catch (error) {
        if (!controller.signal.aborted) {
          console.error("Error fetching entity:", error);
        }
      }
    };

    getEntity();

    return () => controller.abort();
  }, [entity, showCreditsPopup]);

  return (
    <Box
      position="fixed"
      bgColor={"rgba(0, 0, 0, 0.25)"}
      bottom={0}
      right={0}
      top={0}
      left={0}
      zIndex={99999}
    >
      <div
        className={`create_post_popup ${mobile && "create_post_popup_mobile"}`}
        style={{
          width: "400px",
          maxHeight: "90vh",
          height: "auto",
          padding: "24px",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {picker && (
          <Box
            position={mobile ? "fixed" : "absolute"}
            ref={menuRefs}
            zIndex={99}
            borderColor={"#2FA3BE"}
            borderStyle={"solid"}
            borderWidth={"5px"}
            width={mobile ? "85%" : "88%"}
          >
            <AVEmojiPicker
              onEmojiSelect={(emojiObject) => {
                const emoji = emojiObject?.native;
                //if (useRichText && editorRef.current) {
                //  editorRef.current.insertHTML(emoji);
                //} else {
                const ref: any = textRef.current;
                ref.focus();
                const start = textValue.substring(0, ref.selectionStart) || "";
                const end = textValue.substring(ref.selectionStart) || "";
                const newText = start + emoji + end;
                setTextValue(newText);
                //}
                setPicker(false);
              }}
            />
          </Box>
        )}

        <VStack height={"100%"}>
          {/* Header */}
          <HStack
            alignItems={"center"}
            justifyContent={"space-between"}
            borderBottomColor={"AVColor.grey"}
          >
            <Text fontSize={24}>{Loc.currentLang.boostPost.boostPostVia}</Text>
            {/*<HStack space={3} alignItems="center">*/}
            {/*  <AVCancel*/}
            {/*    callback={() => {*/}
            {/*      setShowBoostPostPopup(false);*/}
            {/*    }}*/}
            {/*    color={undefined}*/}
            {/*    size={undefined}*/}
            {/*  />*/}
            {/*</HStack>*/}
          </HStack>

          <ScrollView
            showsHorizontalScrollIndicator={false}
            //top="-20px"
            maxHeight="70vh"
          >
            {/* Dropdown */}
            <HStack
              mt="30px"
              space={3}
              alignItems="center"
              zIndex={isEditorDialogVisible ? "-3" : "unset"}
            >
              <Text fontSize="18">
                {Loc.currentLang.boostPost.boostYourPost} :
              </Text>
              <Box ref={dropdownRef} position="relative">
                <Button
                  width="248px"
                  bgColor="rgba(0, 166, 188, 0.15)"
                  rounded="full"
                  color="#fff"
                  justifyContent="flex-start"
                  minHeight="40px"
                  borderRadius="20px"
                  borderColor="AVColor.primary"
                  onPress={() => setIsActive((prev) => !prev)}
                >
                  <Text color="rgba(0, 167, 188, 1)" fontSize="18px" pl="18px">
                    {!isOwner && sharedPlan?.autoShareType === "NT"
                      ? (paySendOptionsEmail.find(
                          (opt) => opt.value === paySend,
                        )?.label ?? "Select")
                      : (paySendOptionsAll.find((opt) => opt.value === paySend)
                          ?.label ?? "Select")}
                  </Text>
                </Button>

                <Pressable
                  position="absolute"
                  right="12px"
                  top="15px"
                  onPress={() => setIsActive((prev) => !prev)}
                >
                  <DropdownIcon height="9" width="16" />
                </Pressable>

                {isActive && (
                  <VStack
                    position="absolute"
                    top="45px"
                    w="248px"
                    bg="#FFFFFF"
                    borderRadius="8px"
                    shadow="9"
                    zIndex={1000}
                    space={1}
                  >
                    {(!isOwner && sharedPlan?.autoShareType === "NT"
                      ? paySendOptionsEmail
                      : paySendOptionsAll
                    ).map(({ label, value }) => (
                      <Button
                        key={value}
                        variant="ghost"
                        justifyContent="flex-start"
                        onPress={() => {
                          setPaySend(value);
                          setIsActive(false);
                          if (
                            visibility !== Loc.currentLang.menu.organizations &&
                            value > 0
                            //&& (postContent ?? "").trim().length > 0
                          ) {
                            handleGetEstimate(value); // auto-call for non-Org
                          }

                          if (
                            visibility === Loc.currentLang.menu.organizations
                          ) {
                            setEstimate(0);
                          }
                          //setIsEditorDialogVisible(false);
                        }}
                      >
                        <Text
                          color={"black"}
                          fontWeight={paySend === value ? "bold" : "normal"}
                        >
                          {label}
                        </Text>
                      </Button>
                    ))}
                  </VStack>
                )}
              </Box>
            </HStack>

            {/* Text or RTE */}
            <Box
              marginTop={"24px"}
              height="10vh" //{useRichText ? "31vh" : "10vh"}
              //overflowY={useRichText ? "auto" : "unset"}
              borderWidth="1" //{useRichText ? 0 : 1}
              borderRadius="2" //{useRichText ? 0 : 2}
              borderColor={"AVColor.grey"}
              position="relative"
              zIndex={"-3px"}
              //top="-8px"
            >
              {/*{useRichText ? (*/}
              {/*  <SunEditor*/}
              {/*    getSunEditorInstance={(editor) => {*/}
              {/*      editorRef.current = editor;*/}

              {/*      const editorContainer = document*/}
              {/*        .querySelector(".sun-editor-editable.boost-sun-editor")*/}
              {/*        ?.closest(".sun-editor");*/}
              {/*      if (!editorContainer) return;*/}

              {/*      // --- Custom handler: when Link or Image button clicked ---*/}
              {/*      const handleDialogOpen = (e: Event) => {*/}
              {/*        const btn = e.currentTarget as HTMLElement;*/}
              {/*        const command = btn.getAttribute("data-command");*/}

              {/*        if (command === "link" || command === "image") {*/}
              {/*          setIsEditorDialogVisible(true);*/}
              {/*        }*/}
              {/*      };*/}

              {/*      // Custom close handler*/}
              {/*      const handleDialogClose = () => {*/}
              {/*        setIsEditorDialogVisible(false);*/}
              {/*      };*/}

              {/*      // Attach event listeners for the toolbar buttons (link & image)*/}
              {/*      const linkButton = editorContainer.querySelector(*/}
              {/*        'button[data-command="link"]',*/}
              {/*      );*/}
              {/*      const imageButton = editorContainer.querySelector(*/}
              {/*        'button[data-command="image"]',*/}
              {/*      );*/}

              {/*      if (linkButton) {*/}
              {/*        linkButton.addEventListener("click", handleDialogOpen);*/}
              {/*      }*/}
              {/*      if (imageButton) {*/}
              {/*        imageButton.addEventListener("click", handleDialogOpen);*/}
              {/*      }*/}

              {/*      // Watch for dialogs opening (like image insert)*/}
              {/*      const observer = new MutationObserver(() => {*/}
              {/*        // Detect image or link dialog visibility based on style*/}
              {/*        const imageDialog = editorContainer.querySelector(*/}
              {/*          ".se-dialog-image",*/}
              {/*        ) as HTMLElement | null;*/}
              {/*        const linkDialog = editorContainer.querySelector(*/}
              {/*          ".se-dialog-content",*/}
              {/*        ) as HTMLElement | null;*/}
              {/*        const isVisible: boolean = !!(*/}
              {/*          (imageDialog && imageDialog.style.display !== "none") ||*/}
              {/*          (linkDialog && linkDialog.style.display !== "none")*/}
              {/*        );*/}
              {/*        setIsEditorDialogVisible(isVisible);*/}

              {/*        // --- Add listener for Close button ---*/}
              {/*        const closeButtons =*/}
              {/*          editorContainer.querySelectorAll(".se-dialog-close");*/}
              {/*        closeButtons.forEach((btn) => {*/}
              {/*          btn.removeEventListener("click", handleDialogClose); // prevent multiple bindings*/}
              {/*          btn.addEventListener("click", handleDialogClose);*/}
              {/*        });*/}

              {/*        // Find the image file input inside this boost editor only*/}
              {/*        const fileInput = editorContainer.querySelector(*/}
              {/*          "._se_image_file",*/}
              {/*        ) as HTMLInputElement | null;*/}

              {/*        if (*/}
              {/*          fileInput &&*/}
              {/*          !fileInput.parentElement?.querySelector(".file-status")*/}
              {/*        ) {*/}
              {/*          // Add dashed border style*/}
              {/*          const fileContainer = fileInput.closest(*/}
              {/*            ".se-dialog-form-files",*/}
              {/*          ) as HTMLElement | null;*/}
              {/*          if (fileContainer) {*/}
              {/*            fileContainer.style.position = "relative";*/}
              {/*            fileContainer.style.border = "2px dashed #ccc";*/}
              {/*            fileContainer.style.borderRadius = "8px";*/}
              {/*            fileContainer.style.padding = "12px";*/}
              {/*            fileContainer.style.textAlign = "center";*/}
              {/*          }*/}

              {/*          // Create wrapper for labels*/}
              {/*          const statusDiv = document.createElement("div");*/}
              {/*          statusDiv.className = "file-status";*/}
              {/*          statusDiv.innerHTML = `*/}
              {/*            <span class="upload-label">${Loc.currentLang.richText.uploadFile}</span>*/}
              {/*            <span class="file-status-text">${Loc.currentLang.richText.noFileChosen}</span>*/}
              {/*          `;*/}
              {/*          fileInput.parentElement?.appendChild(statusDiv);*/}

              {/*          // Handle file change event*/}
              {/*          fileInput.addEventListener("change", (e: Event) => {*/}
              {/*            const target = e.target as HTMLInputElement;*/}
              {/*            const file = target?.files?.[0] || null;*/}
              {/*            const statusText = statusDiv.querySelector(*/}
              {/*              ".file-status-text",*/}
              {/*            ) as HTMLElement;*/}

              {/*            if (file) {*/}
              {/*              statusText.textContent = file.name;*/}
              {/*              statusText.style.color = "#333";*/}
              {/*            } else {*/}
              {/*              statusText.textContent =*/}
              {/*                Loc.currentLang.richText.noFileChosen;*/}
              {/*              statusText.style.color = "#777";*/}
              {/*            }*/}
              {/*          });*/}
              {/*        }*/}
              {/*      });*/}

              {/*      // Observe editor container for dialogs being added*/}
              {/*      observer.observe(editorContainer, {*/}
              {/*        childList: true,*/}
              {/*        subtree: true,*/}
              {/*      });*/}
              {/*    }}*/}
              {/*    lang={*/}
              {/*      currentUser?.preferences?.lang*/}
              {/*        ? currentUser.preferences.lang === "en-us"*/}
              {/*          ? "en"*/}
              {/*          : currentUser.preferences.lang*/}
              {/*        : "en"*/}
              {/*    }*/}
              {/*    setOptions={{*/}
              {/*      ...toolbarOptions,*/}
              {/*      height: "20vh",*/}
              {/*      className: "boost-sun-editor",*/}
              {/*    }}*/}
              {/*    onChange={(value) => setTextValue(value)}*/}
              {/*    setContents={textValue}*/}
              {/*    autoFocus={true}*/}
              {/*  />*/}
              {/*) : (*/}
              <textarea
                ref={textRef}
                value={textValue}
                style={{
                  border: "none",
                  resize: "none",
                  height: "6vh",
                  padding: "20px 15px",
                  outline: "none",
                  fontFamily: "inherit",
                  fontSize: "inherit",
                  borderColor: "rgba(0, 0, 0, 0.25)",
                }}
                maxLength={50}
                placeholder={Loc.currentLang.boostPost.addSubject}
                onChange={(e) => setTextValue(e.target.value)}
                autoFocus
              />
              {/*)}*/}

              {/* RTE Toolbar - Color Picker */}
              {/*{useRichText && (*/}
              {/*  <div*/}
              {/*    style={{*/}
              {/*      position: "absolute",*/}
              {/*      left: "232px",*/}
              {/*      top: "46px",*/}
              {/*      display: "flex",*/}
              {/*      flexDirection: "row",*/}
              {/*      gap: "10px",*/}
              {/*      border: "1px solid #dadada",*/}
              {/*      borderRadius: "4px",*/}
              {/*      padding: "8px 8px",*/}
              {/*      zIndex: 10,*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    <Box position="relative" display="inline-block">*/}
              {/*      <Tooltip*/}
              {/*        title={Loc.currentLang.postPopup.backgroundColor}*/}
              {/*        arrow*/}
              {/*      >*/}
              {/*        <Pressable*/}
              {/*          onPress={() => setShowColorPicker(!showColorPicker)}*/}
              {/*          style={{*/}
              {/*            display: "flex",*/}
              {/*            alignItems: "center",*/}
              {/*            justifyContent: "center",*/}
              {/*          }}*/}
              {/*        >*/}
              {/*          <BrushIcon height="20" width="20" color="black" />*/}
              {/*        </Pressable>*/}
              {/*      </Tooltip>*/}

              {/*      {showColorPicker && (*/}
              {/*        <div*/}
              {/*          style={{*/}
              {/*            position: "absolute",*/}
              {/*            top: "40px",*/}
              {/*            right: "20px",*/}
              {/*            zIndex: 9999,*/}
              {/*          }}*/}
              {/*          ref={colorPickerRef}*/}
              {/*        >*/}
              {/*          <Box*/}
              {/*            display="flex"*/}
              {/*            flexDirection="column"*/}
              {/*            alignItems="center"*/}
              {/*          >*/}
              {/*            <SketchPicker*/}
              {/*              color={bgColor}*/}
              {/*              onChange={handleColorChange}*/}
              {/*            />*/}
              {/*            {bgColor && (*/}
              {/*              <Tooltip*/}
              {/*                title={*/}
              {/*                  Loc.currentLang.postPopup.removeBackgroundColor*/}
              {/*                }*/}
              {/*                arrow*/}
              {/*              >*/}
              {/*                <Pressable*/}
              {/*                  alignSelf="flex-end"*/}
              {/*                  top="-25px"*/}
              {/*                  left="-14px"*/}
              {/*                  onPress={() => {*/}
              {/*                    setBgColor("");*/}
              {/*                    const editableArea =*/}
              {/*                      document.querySelector<HTMLDivElement>(*/}
              {/*                        ".sun-editor-editable.boost-sun-editor",*/}
              {/*                      );*/}
              {/*                    if (editableArea)*/}
              {/*                      editableArea.style.backgroundColor =*/}
              {/*                        "unset";*/}
              {/*                    setShowColorPicker(false);*/}
              {/*                  }}*/}
              {/*                >*/}
              {/*                  <CircleSlashIcon*/}
              {/*                    width={"14px"}*/}
              {/*                    height={"14px"}*/}
              {/*                  />*/}
              {/*                </Pressable>*/}
              {/*              </Tooltip>*/}
              {/*            )}*/}
              {/*          </Box>*/}
              {/*        </div>*/}
              {/*      )}*/}
              {/*    </Box>*/}
              {/*  </div>*/}
              {/*)}*/}

              {/* Bottom Right Controls */}
              <div
                style={{
                  position: "absolute",
                  right: "10px",
                  bottom: "10px",
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  zIndex: 10,
                }}
              >
                {/* Toggle Rich Text */}
                {/*<Tooltip*/}
                {/*  title={*/}
                {/*    useRichText*/}
                {/*      ? Loc.currentLang.postPopup.plainPost*/}
                {/*      : Loc.currentLang.postPopup.formattingPost*/}
                {/*  }*/}
                {/*  arrow*/}
                {/*>*/}
                {/*  <Pressable*/}
                {/*    top={"2px"}*/}
                {/*    //onPress={handleToggleRichTextSubject}*/}
                {/*    onPress={() => {*/}
                {/*      setUseRichText((prev) => {*/}
                {/*        const newValue = !prev;*/}
                {/*        if (showBoostPostPopup) handleToggleRichTextPost?.();*/}

                {/*        setTimeout(() => {*/}
                {/*          if (newValue) {*/}
                {/*            // Switching TO Rich Text*/}
                {/*            if (subject && !/<[a-z][\s\S]*>/i.test(subject)) {*/}
                {/*              const formattedText = `<p>${subject}</p>`;*/}
                {/*              setSubject(formattedText);*/}

                {/*              const editor = editorRef.current;*/}
                {/*              if (editor) {*/}
                {/*                editor.setContents(formattedText);*/}
                {/*                const editableArea =*/}
                {/*                  editor.core?.context?.element?.wysiwyg;*/}
                {/*                if (editableArea) {*/}
                {/*                  const range = document.createRange();*/}
                {/*                  const selection = window.getSelection();*/}
                {/*                  range.selectNodeContents(editableArea);*/}
                {/*                  range.collapse(false); // move cursor to end*/}
                {/*                  selection?.removeAllRanges();*/}
                {/*                  selection?.addRange(range);*/}
                {/*                }*/}
                {/*              }*/}
                {/*            }*/}
                {/*          } else {*/}
                {/*            // Switching TO Plain Text*/}
                {/*            const tempDiv = document.createElement("div");*/}
                {/*            tempDiv.innerHTML = subject;*/}
                {/*            const plain = (tempDiv.innerText || "")*/}
                {/*              .trim()*/}
                {/*              .replace(/[\u200B-\u200D\uFEFF]/g, "");*/}
                {/*            setSubject(plain);*/}

                {/*            // Remove backgroundImage and backgroundColor*/}
                {/*            setBgColor("");*/}
                {/*            setBgImage("");*/}
                {/*            setBgImgWidth("");*/}
                {/*            setBgImgHeight("");*/}

                {/*            const editableArea =*/}
                {/*              document.querySelector<HTMLDivElement>(*/}
                {/*                ".sun-editor-editable.boost-sun-editor",*/}
                {/*              );*/}
                {/*            if (editableArea) {*/}
                {/*              editableArea.style.backgroundImage = "unset";*/}
                {/*              editableArea.style.backgroundSize = "unset";*/}
                {/*              editableArea.style.backgroundPosition = "unset";*/}
                {/*              editableArea.style.backgroundRepeat = "unset";*/}
                {/*              editableArea.style.backgroundColor = "unset";*/}
                {/*              editableArea.style.width = "unset";*/}
                {/*              editableArea.style.minWidth = "unset";*/}
                {/*            }*/}
                {/*          }*/}
                {/*        }, 200); // small delay for render sync*/}

                {/*        return newValue;*/}
                {/*      });*/}
                {/*    }}*/}
                {/*  >*/}
                {/*    {useRichText ? <PlainTextIcon /> : <FormattingIcon />}*/}
                {/*  </Pressable>*/}
                {/*</Tooltip>*/}

                {/* Emoji */}
                <AVEmoji showEmoji={() => setPicker((prev) => !prev)} />
              </div>
            </Box>

            {/* Credits or No Cost Section */}
            {paySend > 0 ? (
              // Credits Section
              <Box
                mt="15px"
                p="12px"
                //borderRadius="16px"
                bgColor="#fff"
                alignItems="center"
                justifyContent="center"
                zIndex="-3"
                //borderWidth="1px"
                //borderColor="rgba(0,0,0,0.1)"
                //shadow="3"
                //top="-38px"
              >
                {/* Credits Available */}
                <HStack justifyContent="flex-end" width="100%" pr="5px">
                  <Text fontSize="14px" color="rgba(0,0,0,0.6)">
                    {Loc.currentLang.purchaseCredits.Credits}
                  </Text>
                  <HStack alignItems="center" ml="6px" space={1}>
                    <Box
                      bg="#FFF7E6"
                      px="6px"
                      py="2px"
                      borderRadius="8px"
                      display="flex"
                      flexDirection="row"
                      alignItems="center"
                    >
                      <DollarCoinsIcon height="15px" width="15px" />
                      <Text fontSize="sm" color="#D46B08">
                        {creditsAvailable}
                      </Text>
                    </Box>
                  </HStack>
                </HStack>

                <VStack alignItems="center" mt="10px" mb="5px">
                  {visibility === Loc.currentLang.menu.organizations ? (
                    // For Org visibility
                    <>
                      {loading ? (
                        // Show loader when calculating
                        <HStack alignItems="center" mt={2}>
                          <Spinner size="sm" mr={2} color="AVColor.primary" />
                          <Text color="gray.400">
                            {Loc.currentLang.boostPost.calculatingEstimate}
                          </Text>
                        </HStack>
                      ) : estimate && estimate > 0 ? (
                        // Show estimated values AFTER fetching
                        <>
                          <DollarCoinsIcon height="60px" width="60px" />
                          <Text
                            fontSize="22px"
                            fontWeight="700"
                            color="rgba(0,0,0,0.8)"
                          >
                            {estimate} {Loc.currentLang.boostPost.credits}
                          </Text>
                        </>
                      ) : (
                        // Show "Get Estimate" link initially
                        <Pressable
                          onPress={() => {
                            if (
                              paySend > 0
                              //&& (postContent ?? "").trim().length > 0
                            ) {
                              handleGetEstimate();
                            }
                          }}
                          //disabled={!postContent?.trim().length}
                        >
                          <Text
                            color="rgba(0, 167, 188, 1)"
                            mt="2"
                            textDecorationLine="underline"
                          >
                            {Loc.currentLang.boostPost.getBoostEstimate}
                          </Text>
                        </Pressable>
                      )}
                    </>
                  ) : (
                    // For non-Org visibility (always show estimate)
                    <>
                      {loading ? (
                        // Show loader when calculating
                        <HStack alignItems="center" mt={2}>
                          <Spinner size="sm" mr={2} color="AVColor.primary" />
                          <Text color="gray.400">
                            {Loc.currentLang.boostPost.calculatingEstimate}
                          </Text>
                        </HStack>
                      ) : estimate && estimate > 0 ? (
                        <>
                          <DollarCoinsIcon height="60px" width="60px" />
                          <Text
                            fontSize="22px"
                            fontWeight="700"
                            color="rgba(0,0,0,0.8)"
                          >
                            {estimate} {Loc.currentLang.boostPost.credits}
                          </Text>
                        </>
                      ) : (
                        // Fallback if estimate not available yet
                        <Text color="gray.400" mt="2">
                          {Loc.currentLang.boostPost.estimateNotAvailable}
                        </Text>
                      )}
                    </>
                  )}
                </VStack>

                {/* Info Texts (always visible if there’s any estimate section) */}
                <Text
                  textAlign="center"
                  mt="8px"
                  fontSize="14px"
                  color="rgba(0,0,0,0.6)"
                  px="10px"
                >
                  {Loc.currentLang.boostPost.helpTextUSACost}
                </Text>

                <Text
                  textAlign="center"
                  mt="8px"
                  fontSize="14px"
                  color="rgba(0,0,0,0.6)"
                  px="10px"
                >
                  {Loc.currentLang.boostPost.helpTextLowerCharges}
                </Text>

                {/* Buy More Credits Link */}
                {(sharedPlan?.owner?.id === finalEntity?.id || !sharedPlan) && (
                  <Pressable
                    mt="12px"
                    onPress={() => setShowCreditsPopup(true)}
                  >
                    <Text
                      fontSize="sm"
                      color="rgba(0, 167, 188, 1)"
                      textDecorationLine="underline"
                    >
                      {Loc.currentLang.manageConversation.buyMoreCredits}
                    </Text>
                  </Pressable>
                )}
              </Box>
            ) : (
              // No Cost Section
              <Box
                mt="30px"
                p="20px"
                //borderRadius="16px"
                bgColor="#fff"
                alignItems="center"
                justifyContent="center"
                zIndex="-3"
                //borderWidth="1px"
                //borderColor="rgba(0,0,0,0.1)"
                //shadow="3"
                //top={useRichText ? "-30px" : "unset"}
              >
                <Text
                  fontSize="22px"
                  fontWeight="700"
                  color="rgba(0,0,0,0.8)"
                  mb="5px"
                >
                  {Loc.currentLang.boostPost.noCost}
                </Text>
                <Text
                  fontSize="14px"
                  textAlign="center"
                  color="rgba(0,0,0,0.6)"
                >
                  {Loc.currentLang.boostPost.helpText}
                </Text>
              </Box>
            )}
          </ScrollView>

          {/* Footer */}
          <Box position="relative" zIndex={10}>
            <HStack justifyContent="space-between" alignItems="center" w="100%">
              <HStack space={3}>
                <Button
                  height={"40px"}
                  width={"180px"}
                  backgroundColor={"rgba(238, 238, 238, 1)"}
                  borderRadius={"full"}
                  onPress={() => {
                    setPaySend(editPostPaySend ?? 0);
                    setSubject(editPostSubject ?? "");
                    setShowBoostPostPopup(false);
                    setShowCreditsPopup(false);
                    setIsEditorDialogVisible(false);
                  }}
                >
                  <Text
                    fontWeight={400}
                    color={"rgba(0, 0, 0, 0.5)"}
                    fontSize={"16px"}
                  >
                    {Loc.currentLang.postPopup.cancel}
                  </Text>
                </Button>

                <Button
                  height={"40px"}
                  width={"180px"}
                  backgroundColor={"AVColor.primary"}
                  borderRadius={"full"}
                  onPress={handleOk}
                  isDisabled={
                    /*!useRichText && */ textValue.trim().length === 0 || // Plain text empty
                    //(useRichText && !hasContent(textValue)) || // Rich text empty
                    creditsAvailable === 0 || // Not enough credits
                    (estimate ?? 0) === 0 || // Estimate not available
                    creditsAvailable < (estimate ?? 0) || // Not enough credits
                    (editPostSubject === undefined && paySend === 0) // Nothing to edit and no Boost option selected
                  }
                >
                  <Text color={"white"} fontWeight={400} fontSize={"16px"}>
                    {Loc.currentLang.menu.ok}
                  </Text>
                </Button>
              </HStack>
            </HStack>
          </Box>
        </VStack>
      </div>
    </Box>
  );
};

export default AVBoostPostPopup;
